import React from 'react';

const EmptyData = () => {
    return (
        <div className={'p-2 flex align-items-center justify-content-center'}>
            <div className={'text-center'}>
                <div>
                    <img alt={'No Data'} height={200} width={200} src={'https://static.vecteezy.com/system/resources/thumbnails/010/856/652/small_2x/no-result-data-document-or-file-not-found-concept-illustration-flat-design-eps10-modern-graphic-element-for-landing-page-empty-state-ui-infographic-icon-etc-vector.jpg'} />
                </div>
                <h4>No Data Found</h4>
            </div>
        </div>
    );
};

export default EmptyData;